import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
/**
 * Lightweight theming provider that exposes CSS custom properties under the React subtree.
 *
 * Components in this package read the following CSS variables when present:
 *  - --cmp-bg, --cmp-text, --cmp-border, --cmp-backdrop, --cmp-shadow, --cmp-radius
 *  - --cmp-btn-primary-bg, --cmp-btn-primary-text, --cmp-btn-primary-hover-bg
 *  - --cmp-btn-secondary-bg, --cmp-btn-secondary-text, --cmp-btn-secondary-border
 *
 * Example:
 *  <CmpThemeProvider theme={{ bg: '#fff', text: '#111827', btnPrimaryBg: '#0ea5e9' }}>
 *    <ConsentBanner />
 *  </CmpThemeProvider>
 */
export function CmpThemeProvider({ theme, className, children, }) {
    const style = React.useMemo(() => {
        const vars = {};
        const add = (key, val) => {
            if (val == null)
                return;
            vars[`--${key}`] = val;
        };
        add('cmp-bg', theme.bg);
        add('cmp-text', theme.text);
        add('cmp-border', theme.border);
        add('cmp-backdrop', theme.backdrop);
        add('cmp-shadow', theme.shadow);
        add('cmp-radius', theme.radius);
        add('cmp-btn-primary-bg', theme.btnPrimaryBg);
        add('cmp-btn-primary-text', theme.btnPrimaryText);
        add('cmp-btn-primary-hover-bg', theme.btnPrimaryHoverBg);
        add('cmp-btn-secondary-bg', theme.btnSecondaryBg);
        add('cmp-btn-secondary-text', theme.btnSecondaryText);
        add('cmp-btn-secondary-border', theme.btnSecondaryBorder);
        return vars;
    }, [theme]);
    return (_jsx("div", { "data-cmp": "cmp-theme", className: className, style: style, children: children }));
}
//# sourceMappingURL=ThemeProvider.js.map